namespace appn.views.brandCenter.site {
    class InitArgs {
        defaultSideMenuJson: string = appn.emptyString;
        sideMenuHint: string = appn.emptyString;
        defaultScss: string = appn.emptyString;
        publishedScss: string = appn.emptyString;
        publishedCss: string = appn.emptyString;
        publishedScripts: string = appn.emptyString;
        publishedSidemenu: string = appn.emptyString;
        builtInPlaceholders: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();
    }

   // Boxlet consts
    const maxRowIdx = 1;
    const maxColIdx = 2;
    const maxSlotIdx = 1;

    function setBoxletIndicesAndBtns() {
        for (let r = 0; r <= maxRowIdx; r++) {
            for (let c = 0; c <= maxColIdx; c++) {
                let $cell = $(`.homeConfig .hp-row-${r}.hp-col-${c}`);
                let $boxlets = $cell.children('.boxlet');

                for (let s = 0; s < $boxlets.length; s++) {
                    let $boxlet = $boxlets.eq(s);
                    let boxId = $boxlet.attr('id') as string;

                    // set Row, Col, Slot based on order of appearance
                    $boxlet.find(`#${boxId}__Row`).val(r);
                    $boxlet.find(`#${boxId}__Col`).val(c);
                    $boxlet.find(`#${boxId}__Slot`).val(s);

                    $boxlet.find('.btn-move-left').removeClass('d-none').toggle(c > 0);
                    $boxlet.find('.btn-move-up').removeClass('d-none').toggle(r > 0 || s > 0);
                    $boxlet.find('.btn-move-down').removeClass('d-none').toggle(r < maxRowIdx || s < $boxlets.length-1);
                    $boxlet.find('.btn-move-right').removeClass('d-none').toggle(c < maxColIdx);
                }
            }
        }
    }

    function removeBoxletItem(this: HTMLElement, event: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        event.preventDefault();

        let $tableBody = $(this).parents('tbody');

        $(this).parents('tr').remove();

        // reindex remaining rows
        $tableBody.find('tr').each(function(trIdx, trElement) {
            $(this).find('select,input').each(function(inputIdx, inputElement) {
                let id = $(inputElement).attr('id') as string;
                id = id.replace(/__Items_[0-9]+__/g, `__Items_${trIdx}__`);
                $(inputElement).attr('id', id);

                let name = $(inputElement).attr('name') as string;
                name = name.replace(/\.Items\[[0-9]+\]\./g, `.Items[${trIdx}].`);
                $(inputElement).attr('name', name);
            });
        });
    }

    function addEvents() {

        // Code Mirror editors
        const scssEditor = appn.codeMirror.applyToTextArea('#WaaSDetails_PreviewableWaasConfigs_CustomScss', appn.codeMirror.codeTypes.scss);
        const cssEditor = appn.codeMirror.applyToTextArea('#WaaSDetails_PreviewableWaasConfigs_CustomCss', appn.codeMirror.codeTypes.css);
        const scriptEditor = appn.codeMirror.applyToTextArea('#WaaSDetails_PreviewableWaasConfigs_CustomScript', appn.codeMirror.codeTypes.htmlAndScript);
        const sideMenuEditor = appn.codeMirror.applyToTextArea('#SideMenuJson', appn.codeMirror.codeTypes.json);

        // no restore/default functionality on public panel, so no var name needed
        appn.codeMirror.applyToTextArea('#WaaSDetails_CustomPublicPanel', appn.codeMirror.codeTypes.htmlAndScript);

        // Boxlet controls

        // Change boxlet type
        $('.boxlet select.boxletType').on('change', function(event) {
            $('form#appnForm').append(`<input type="hidden" name="submitType" value="BoxletChange" />`).submit();
        });

        // Remove boxlet
        $('.boxlet .boxletTools button.delete_button').on('click', function(event) {
            event.preventDefault();

            $(this).parents('.boxlet').remove();

            $('form#appnForm').append(`<input type="hidden" name="submitType" value="BoxletChange" />`).submit();
        });

        // Move boxlet
        let moveLock: boolean = false;
        $(".boxlet button[class^='btn-move-']").on('click', function(event) {
            event.preventDefault();

            let direction = $(this).attr('class')?.split(' ')[0]?.split('-')[2];

            let $boxlet = $(this).parents('.boxlet');
            let boxId = $boxlet.attr('id') as string;
            let fromRow = $boxlet.find(`#${boxId}__Row`).val() as number;
            let fromCol = $boxlet.find(`#${boxId}__Col`).val() as number;
            let fromSlot = $boxlet.find(`#${boxId}__Slot`).val() as number;

            function doMove($target: JQuery<HTMLElement>, fnMove: Function) {
                if (moveLock)
                    return;

                moveLock = true;
                $target.fadeOut(500, function() {
                    $(this).slideUp(150, function() {
                        fnMove();
                        $(this).fadeIn(250);
                        setBoxletIndicesAndBtns();
                        moveLock = false;
                    });
                });
            }

            if (direction === 'up') {
                if (fromSlot <= 0 && fromRow <= 0)          // nothing to do
                    return;

                if (fromSlot > 0) {
                    var $prev = $boxlet.prev();
                    doMove($boxlet, function() {
                        $boxlet.insertBefore($prev);
                    });
                }
                else if (fromRow > 0) {
                    let toRow = fromRow - 1;
                    let $toCell = $(`.homeConfig .hp-row-${toRow}.hp-col-${fromCol}`);
                    let $toSiblings = $toCell.children('.boxlet');

                    if ($toSiblings.length > maxSlotIdx)         // cell already at max slots
                        return;

                    doMove($boxlet, function() {
                        if ($toSiblings.length === 0)
                            $boxlet.prependTo($toCell);
                        else
                            $boxlet.insertAfter($toSiblings);
                    });
                }
            } else if (direction === 'down') {
                if (fromSlot >= maxSlotIdx && fromRow >= maxRowIdx)
                    return;

                if (fromSlot < maxSlotIdx && $boxlet.next('.boxlet').length > 0) {
                    var $next = $boxlet.next();
                    doMove($boxlet, function() {
                        $boxlet.insertAfter($next);
                    });
                }
                else if (fromRow < maxRowIdx) {
                    let toRow = Number(fromRow) + 1;
                    let $toCell = $(`.homeConfig .hp-row-${toRow}.hp-col-${fromCol}`);
                    let $toSiblings = $toCell.children('.boxlet');

                    if ($toSiblings.length > maxSlotIdx)         // cell already at max slots
                        return;

                    doMove($boxlet, function() {
                        if ($toSiblings.length === 0)
                            $boxlet.prependTo($toCell);
                        else
                            $boxlet.insertBefore($toSiblings);
                    });
                }
            } else if (direction === 'left') {
                if (fromCol <= 0)
                    return;

                let toCol = Number(fromCol) - 1;
                let $toCell = $(`.homeConfig .hp-row-${fromRow}.hp-col-${toCol}`);
                let $toSiblings = $toCell.children('.boxlet');

                if ($toSiblings.length > maxSlotIdx)         // cell already at max slots
                    return;

                doMove($boxlet, function() {
                    if ($toSiblings.length === 0)
                        $boxlet.prependTo($toCell);
                    else
                        $boxlet.insertAfter($toSiblings);
                });

            } else if (direction === 'right') {
                if (fromCol >= maxColIdx)
                    return;

                let toCol = Number(fromCol) + 1;
                let $toCell = $(`.homeConfig .hp-row-${fromRow}.hp-col-${toCol}`);
                let $toSiblings = $toCell.children('.boxlet');

                if ($toSiblings.length > maxSlotIdx)         // cell already at max slots
                    return;

                doMove($boxlet, function() {
                    if ($toSiblings.length === 0)
                        $boxlet.prependTo($toCell);
                    else
                        $boxlet.insertAfter($toSiblings);
                });
            }
        });

        // Boxlet Items - remove
        $('.boxletItems .delete_button').on('click', removeBoxletItem);

        // Boxlet Items - add
        $('.boxletItems .addBoxletItem').on('click', function(event) {
            event.preventDefault();

            let $container = $(this).parents('.boxletItems');
            let $tableBody = $container.find('table tbody');
            let nextIdx = $tableBody.children().length;

            var rowHtml = $tableBody.find('tr').last()[0].outerHTML as any;

            rowHtml = rowHtml.replaceAll(`Items_${(nextIdx - 1).toString()}_`, `Items_${nextIdx.toString()}_`)
                .replaceAll(`Items[${(nextIdx - 1).toString()}]`, `Items[${nextIdx.toString()}]`);

            let $newRow = $(rowHtml);

            $tableBody.append($newRow);

            // wire delete button
            $newRow.find('.delete_button').on('click', removeBoxletItem);
        });

        // SCSS EDITOR
        $('.restore-default-scss').on('click', function() {
            scssEditor?.setValue(_initArgs.defaultScss);
            appn.toast.notify(toast.Type.info, T(`Default SCSS has been restored, don't forget to hit Preview or Publish.`));
        });
        $('.restore-published-scss').on('click', function() {
            scssEditor?.setValue(_initArgs.publishedScss);
            appn.toast.notify(toast.Type.info, T(`Published SCSS has been restored, don't forget to hit Preview or Publish.`));
        });

        // CUSTOM CSS EDITOR
        $('.restore-published-css').on('click', function() {
            cssEditor?.setValue(_initArgs.publishedCss);
            appn.toast.notify(toast.Type.info, T(`Published CSS has been restored, don't forget to hit Preview or Publish.`));
        });

        // CUSTOM SCRIPT EDITOR
        $('.restore-published-customscript').on('click', function() {
            scriptEditor?.setValue(_initArgs.publishedScripts);
            appn.toast.notify(toast.Type.info, T(`Published Custom Script has been restored, don't forget to hit Preview or Publish.`));
        });

        // SIDEMENU JSON EDITOR
        $('.restore-default-sidemenu').on('click', function() {
            sideMenuEditor?.setValue(_initArgs.defaultSideMenuJson);
            appn.toast.notify(toast.Type.info, T(`Default Side Menu has been restored, don't forget to hit Preview or Publish.`));
        });
        $('.restore-published-sidemenu').on('click', function() {
            sideMenuEditor?.setValue(_initArgs.publishedSidemenu);
            appn.toast.notify(toast.Type.info, T(`Published Side Menu has been restored, don't forget to hit Preview or Publish.`));
        });

        $('.btn-view-sidemenu-definition').on('click', function(event) {
            event.preventDefault();
            appn.dialog.alert({
                modalColor: 'modal-info',
                size: 'large',
                title: T('Side Menu JSON Definition'),
                message: _initArgs.sideMenuHint,
                autoHeaderIcon: false
            });
        });

        $('.btn-built-in-placeholders').on('click', function(event) {
            event.preventDefault();
            appn.dialog.alert({
                modalColor: 'modal-info',
                size: 'large',
                title: T('Built-in Placeholders'),
                message: _initArgs.builtInPlaceholders,
                autoHeaderIcon: false
            });
        });

        $('.btn-enableOrPublishPreview').on('click', function(event) {
            event.preventDefault();
            const enableOrPublish = $(this).data('btnaction');

            if (validateDomain())
                return;

            if (enableOrPublish === 'EnablePreview')
                appn.dialog.confirm({
                    modalColor: 'modal-info',
                    title: T('Enable WaaS Preview?'),
                    message: T('This will enable the Waas preview across the entire platform. It will only be visible/enabled for you, other users will not see this preview. Use this preview to test out your custom SCSS, CSS, Script and Side Menu changes. This will also Save your changes to General, Branding and Home Screen & Catalog sections. Hit Publish when you are happy with your changes.<br><br>Hit <b>OK</b> to start the Preview.'),
                    callback: function (result: any) {
                        if (result)
                            $('form#appnForm').append(`<input type="hidden" name="submitType" value="${enableOrPublish}" />`).submit();
                    }
                });
            else
                appn.dialog.confirm({
                    modalColor: 'modal-warning',
                    title: T('Publish Styling & Behaviour?'),
                    message: T('This will publish any custom SCSS, CSS, Scripts and Side Menu changes you may have made. This will also Save your changes to General, Branding and Home Screen & Catalog sections. It is a good idea to preview these changes if you havent already.  Publishing these settings will apply to all users across the platform.<br><br>Hit <b>OK</b> to Publish your changes.'),
                    callback: function (result: any) {
                        if (result)
                            $('form#appnForm').append(`<input type="hidden" name="submitType" value="${enableOrPublish}" />`).submit();
                    }
                });
        });
    }

    function validateDomain(): boolean {
        const domainEle = $('#WaaSDetails_AllowedEmbeddingDomain');
        const domain: string = domainEle.val() as string;

        if (!utils.hasValue(domain))
            return false;

        let url: any = undefined;
        const container = domainEle.closest("div");
        const validationContainer = container.find("[data-valmsg-for]");
        let errorText = T('Invalid URL. Please check and try again with a valid URL (e.g. https://www.example.com).');
        let error = `<span for="${(validationContainer.attr('data-valmsg-for')?.replace('.', '_'))}" generated="true" class="">${errorText}</span>`;
        let hasError = false;
        try {
            url = new URL(domain);
            if (url!.protocol !== 'https:') {
                errorText = T('Invalid URL. The URL must use an HTTPS protocol (e.g. https://www.example.com).');
                error = `<span for="${(validationContainer.attr('data-valmsg-for')?.replace('.', '_'))}" generated="true" class="">${errorText}</span>`;
                validationContainer.html('');
                validationContainer.append(error);
                hasError = true;
            }
        } catch (_) {
            validationContainer.html('');
            validationContainer.append(error);
            hasError = true;
        }
        if (hasError) {
            validationContainer.removeClass('field-validation-valid');
            validationContainer.addClass('field-validation-error');
        }
        else {
            validationContainer.addClass('field-validation-valid');
            validationContainer.removeClass('field-validation-error');
        }
        validationContainer[0].scrollIntoView({behavior: "smooth", block: "start"});
        return hasError;
    }
}
